export const payPeriodTypeValues = ['weekly'] as const;
export type PayPeriodType = (typeof payPeriodTypeValues)[number];

export const weekStartsOnValues = [0, 1, 2, 3, 4, 5, 6] as const;
export type WeekStartsOn = (typeof weekStartsOnValues)[number];

export const overtimePolicyTypeValues = ['weekly'] as const;
export type OvertimePolicyType = (typeof overtimePolicyTypeValues)[number];

export const closePayPeriodPermissionKey = 'timeTracking.period.close' as const;
export type ClosePayPeriodPermissionKey = typeof closePayPeriodPermissionKey;

export interface WeeklyOvertimePolicyDto {
  type: 'weekly';
  thresholdMinutes: number;
}

export type OvertimePolicyDto = WeeklyOvertimePolicyDto;

export interface TimeTrackingSettingsDto {
  id: string;
  companyId: string;
  payPeriodType: PayPeriodType;
  timezone: string;
  weekStartsOn: WeekStartsOn;
  overtimePolicy: OvertimePolicyDto;
  closePeriodRequiresPermission: ClosePayPeriodPermissionKey;
  createdAt: string;
  updatedAt: string;
}

export interface GetTimeTrackingSettingsRequest {
  companyId: string;
}

export interface GetTimeTrackingSettingsResponse {
  settings: TimeTrackingSettingsDto;
}

export interface UpdateTimeTrackingSettingsRequest {
  companyId: string;
  payPeriodType: PayPeriodType;
  timezone: string;
  weekStartsOn: WeekStartsOn;
  overtimePolicy: OvertimePolicyDto;
}

export interface UpdateTimeTrackingSettingsResponse {
  settings: TimeTrackingSettingsDto;
}

